// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';

// 引入你的页面组件
import HomePage from '../view/HomePage.vue';
import NewsPage from '../view/NewsPage.vue';
import NewsDetail from '../view/NewsDetail.vue';
import SupportPage from '../view/SupportPage.vue';
import AboutPage from '../view/AboutPage.vue';
import SolutionPage1 from '../view/SolutionPage1.vue';
import SolutionPage2 from '../view/SolutionPage2.vue';
import SolutionPage3 from '../view/SolutionPage3.vue';
import SolutionPage4 from '../view/SolutionPage4.vue';
import ProductPage1 from '../view/ProductPage1.vue';
import ProductPage2 from '../view/ProductPage2.vue';
import ProductPage3 from '../view/ProductPage3.vue';


// 使用 VueRouter
Vue.use(VueRouter);

// 定义路由
const routes = [{
        path: '/',
        name: 'HomePage',
        component: HomePage,
    },
    {
        path: '/news',
        name: 'NewsPage',
        component: NewsPage,
    },
    {
        path: '/news/details',
        name: 'NewsDetail',
        component: NewsDetail,
    },
    {
        path: '/support',
        name: 'SupportPage',
        component: SupportPage,
    },
    {
        path: '/about',
        name: 'AboutPage',
        component: AboutPage,
    },
    {
        path: '/SolutionPage1',
        name: 'SolutionPage1',
        component: SolutionPage1,
    },
    {
        path: '/SolutionPage2',
        name: 'SolutionPage2',
        component: SolutionPage2,
    },
    {
        path: '/SolutionPage3',
        name: 'SolutionPage3',
        component: SolutionPage3,
    },
    {
        path: '/SolutionPage4',
        name: 'SolutionPage4',
        component: SolutionPage4,
    },
    {
        path: '/ProductPage1',
        name: 'ProductPage1',
        component: ProductPage1,
    },
    {
        path: '/ProductPage2',
        name: 'ProductPage2',
        component: ProductPage2,
    },
    {
        path: '/ProductPage3',
        name: 'ProductPage3',
        component: ProductPage3,
    },

];


// 创建 router 实例
const router = new VueRouter({
    mode: 'history', // 使用 history 模式
    routes, // 传递路由配置
});

export default router;